import { CalendarClock, LayoutDashboard, Phone, Shield, Target } from 'lucide-vue-next';
import { ref } from 'vue';

import type { NavGroup } from '@/components/app-sidebar/types';

export function useSidebar() {
  const navData = ref<NavGroup[]>();

  navData.value = [
    {
      title: 'General',
      items: [
        {
          title: 'Dashboard',
          icon: LayoutDashboard,
          url: '/dashboard',
        },
        {
          title: 'Staff Timeline',
          icon: CalendarClock,
          url: '/staff-timeline',
          hideOnMobile: true,
        },
        {
          title: 'Call Table',
          icon: Phone,
          url: '/calls',
        },
        {
          title: 'Lead Tracker',
          icon: Target,
          url: '/lead-tracker',
        },
      ],
    },
    {
      title: 'Settings',
      items: [
        {
          title: 'Access Management',
          icon: Shield,
          url: '/access-management',
        },
      ],
    },
    // Hide Other Settings section for now
    // {
    //   title: 'Other',
    //   items: [
    //     {
    //       title: 'Settings',
    //       icon: Settings,
    //       items: [{ title: 'Profile', url: '/settings/', icon: User }],
    //     },
    //   ],
    // },
  ];

  const otherPages = ref<NavGroup[]>([
    /* Hide Billing page
    {
      title: 'Other',
      items: [
        {
          title: 'Plans & Pricing',
          icon: CreditCard,
          url: '/billing',
        },
      ],
    },
    */
  ]);

  return {
    navData,
    otherPages,
  };
}
